import { getLogger } from '@cian/logger/browser';
import { Base64 } from 'js-base64';
import { EInternalAdfoxBannerErrors } from '../enums/EInternalAdfoxBannerErrors';
/** @description Парсит и декодирует параметры из бандла */
export function parseDecodeParams(_ref) {
  var bundleName = _ref.bundleName,
    bundleParams = _ref.bundleParams;
  var parsedDecodedParams = {};
  var internalBannerErrorData = null;
  if (bundleName === 'banner.transfer' && bundleParams.htmlBase64) {
    try {
      var decodedParams = Base64.decode(bundleParams.htmlBase64);
      parsedDecodedParams = JSON.parse(decodedParams);
    } catch (e) {
      var domain = 'src/utils/parseDecodeParams.ts';
      if (e instanceof Error) {
        internalBannerErrorData = {
          errorMessage: e.message,
          errorType: EInternalAdfoxBannerErrors.JsonParse
        };
        getLogger().error(e, {
          domain: domain,
          message: 'Failed to parse decoded params'
        });
      } else {
        internalBannerErrorData = {
          errorMessage: 'Неизвестная ошибка, это не инстанс Error',
          errorType: EInternalAdfoxBannerErrors.JsonParse
        };
        getLogger().error('Неизвестная ошибка, это не инстанс Error', {
          domain: domain,
          message: 'Failed to parse decoded params'
        });
      }
    }
  }
  return {
    internalBannerErrorData: internalBannerErrorData,
    parsedDecodedParams: parsedDecodedParams
  };
}